import type { RouteObject } from "react-router-dom";

import { ReviewScreen } from "./ReviewScreen";

// Discovered by 06b's `router.tsx`, which globs `./screens/*/routes.tsx`. Absolute paths (§B1.3).
// (The glob pattern is written in a line comment on purpose: inside a `/** … */` block its `*/` would close
// the comment early and the file would not parse.)
export const routes: RouteObject[] = [{ path: "/migrations/:migrationId/review", element: <ReviewScreen /> }];
